// Machine-assisted patient-facing role family translations. All locale records are
// complete drafts, NOT professionally translated or clinically approved releases.
// Keep titles, scope, seniority and student supervision linked to English source IDs.
export const NON_SURGEON_ROLE_FAMILY_DRAFTS = {
  "fr": {
    "midwife": {
      "consultant_midwife": [
        "Sage-femme consultante",
        "Sage-femme très expérimentée qui apporte une expertise clinique, dirige des équipes et contribue à améliorer les services de maternité.",
        "La sage-femme consultante exerce des responsabilités cliniques et de leadership avancées. Elle peut intervenir dans des situations complexes, donner des avis spécialisés et améliorer les pratiques et services."
      ],
      "student_midwife": [
        "Étudiant ou étudiante sage-femme",
        "Personne en formation pour devenir sage-femme diplômée, avec une supervision adaptée à son niveau de formation.",
        "La personne étudiante est encore en formation. Ses activités dépendent de ses compétences, de son niveau de formation et de la supervision disponible. Une sage-femme diplômée veille à ce que les soins soient correctement supervisés."
      ]
    },
    "summary": "Professionnel infirmier spécialisé dans {area}.",
    "difference": "Cette spécialité se concentre sur {area}, notamment {scope}.",
    "specialties": {
      "cancer_cns": [
        "Infirmier ou infirmière spécialiste du cancer",
        "les soins en cancérologie",
        "l'accompagnement lors du diagnostic, du traitement et du suivi"
      ],
      "breast_cancer_cns": [
        "Infirmier ou infirmière spécialiste du cancer du sein",
        "les soins liés au cancer du sein",
        "le parcours de soins, les traitements et le soutien"
      ],
      "cardiac_cns": [
        "Infirmier ou infirmière spécialiste en cardiologie",
        "la prise en charge des maladies cardiaques",
        "les traitements et le soutien continu"
      ],
      "diabetes_cns": [
        "Infirmier ou infirmière spécialiste du diabète",
        "les soins du diabète",
        "les traitements, l'éducation thérapeutique et les situations complexes"
      ],
      "respiratory_cns": [
        "Infirmier ou infirmière spécialiste en pneumologie",
        "les maladies pulmonaires et respiratoires",
        "l'évaluation, les traitements et le soutien"
      ],
      "neurology_cns": [
        "Infirmier ou infirmière spécialiste en neurologie",
        "les maladies neurologiques",
        "les traitements et le soutien"
      ],
      "palliative_care_cns": [
        "Infirmier ou infirmière spécialiste en soins palliatifs",
        "les soins palliatifs",
        "le soulagement des symptômes, le soutien et la qualité de vie en cas de maladie grave"
      ]
    }
  },
  "es": {
    "midwife": {
      "consultant_midwife": [
        "Matrona consultora",
        "Matrona con amplia experiencia y responsabilidades clínicas avanzadas, de liderazgo y de mejora de los servicios.",
        "La matrona consultora tiene experiencia clínica avanzada y funciones de liderazgo. Puede participar en cuidados complejos, asesoramiento especializado y mejora de los servicios de maternidad."
      ],
      "student_midwife": [
        "Estudiante de matronería",
        "Persona que se está formando para ser matrona titulada y trabaja bajo una supervisión adecuada a su etapa de formación.",
        "La persona estudiante aún está en formación. Las tareas que puede realizar dependen de su nivel, sus competencias y la supervisión. Una matrona titulada sigue siendo responsable de garantizar la supervisión adecuada de los cuidados."
      ]
    },
    "summary": "Profesional de enfermería clínica especializado en {area}.",
    "difference": "Esta especialidad se centra en {area}, incluido {scope}.",
    "specialties": {
      "cancer_cns": [
        "Enfermero o enfermera especialista en cáncer",
        "la atención oncológica",
        "el apoyo durante el diagnóstico, el tratamiento y el seguimiento"
      ],
      "breast_cancer_cns": [
        "Enfermero o enfermera especialista en cáncer de mama",
        "la atención del cáncer de mama",
        "el itinerario asistencial, el tratamiento y el apoyo"
      ],
      "cardiac_cns": [
        "Enfermero o enfermera especialista en cardiología",
        "las enfermedades cardíacas",
        "el tratamiento y el apoyo continuado"
      ],
      "diabetes_cns": [
        "Enfermero o enfermera especialista en diabetes",
        "la atención de la diabetes",
        "el tratamiento, la educación y los casos complejos"
      ],
      "respiratory_cns": [
        "Enfermero o enfermera especialista en neumología",
        "las enfermedades pulmonares y respiratorias",
        "la evaluación, el tratamiento y el apoyo"
      ],
      "neurology_cns": [
        "Enfermero o enfermera especialista en neurología",
        "las enfermedades neurológicas",
        "el tratamiento y el apoyo"
      ],
      "palliative_care_cns": [
        "Enfermero o enfermera especialista en cuidados paliativos",
        "los cuidados paliativos",
        "el alivio de los síntomas, el apoyo y la calidad de vida en enfermedades graves"
      ]
    }
  },
  "ar": {
    "midwife": {
      "consultant_midwife": [
        "القابلة الاستشارية",
        "قابلة ذات خبرة واسعة ومسؤوليات متقدمة في الرعاية السريرية والقيادة وتطوير الخدمات.",
        "القابلة الاستشارية قابلة خبيرة تتولى مسؤوليات سريرية وقيادية متقدمة. وقد تشارك في رعاية الحالات المعقدة، وتقديم المشورة المتخصصة، وتحسين الخدمات، والقيادة المهنية."
      ],
      "student_midwife": [
        "طالب أو طالبة قبالة",
        "شخص يتدرّب ليصبح قابلة مسجّلة، ويعمل تحت إشراف يتناسب مع مرحلته التدريبية.",
        "لا يزال طالب أو طالبة القبالة في مرحلة التدريب. وتعتمد المهام التي يمكنه القيام بها على مرحلة التدريب والكفاءة والإشراف. وتبقى القابلة المسجّلة مسؤولة عن ضمان الإشراف المناسب على الرعاية."
      ]
    },
    "summary": "اختصاصي أو اختصاصية تمريض سريري ذو خبرة في {area}.",
    "difference": "يركّز هذا التخصص على {area}، بما في ذلك {scope}.",
    "specialties": {
      "cancer_cns": [
        "اختصاصي تمريض سريري في رعاية السرطان",
        "رعاية مرضى السرطان",
        "الدعم أثناء التشخيص والعلاج والمتابعة"
      ],
      "breast_cancer_cns": [
        "اختصاصي تمريض سريري في سرطان الثدي",
        "رعاية مرضى سرطان الثدي",
        "مسار الرعاية والعلاج والدعم"
      ],
      "cardiac_cns": [
        "اختصاصي تمريض سريري في أمراض القلب",
        "رعاية أمراض القلب",
        "العلاج والدعم المستمر"
      ],
      "diabetes_cns": [
        "اختصاصي تمريض سريري في السكري",
        "رعاية مرضى السكري",
        "العلاج والتثقيف الصحي والتعامل مع الحالات المعقدة"
      ],
      "respiratory_cns": [
        "اختصاصي تمريض سريري في أمراض الجهاز التنفسي",
        "أمراض الرئة والتنفس",
        "التقييم والعلاج والدعم"
      ],
      "neurology_cns": [
        "اختصاصي تمريض سريري في طب الأعصاب",
        "الأمراض العصبية",
        "العلاج والدعم"
      ],
      "palliative_care_cns": [
        "اختصاصي تمريض سريري في الرعاية التلطيفية",
        "الرعاية التلطيفية",
        "تخفيف الأعراض والدعم وتحسين جودة الحياة عند الإصابة بمرض خطير"
      ]
    }
  },
  "pt": {
    "midwife": {
      "consultant_midwife": [
        "Enfermeira obstetra consultora",
        "Profissional de obstetrícia muito experiente, com responsabilidades clínicas avançadas, de liderança e de melhoria dos serviços.",
        "A profissional consultora de obstetrícia tem experiência clínica avançada e funções de liderança. Pode apoiar cuidados complexos, dar aconselhamento especializado e ajudar a melhorar os serviços de maternidade."
      ],
      "student_midwife": [
        "Estudante de obstetrícia",
        "Pessoa em formação para se qualificar como profissional de obstetrícia, com supervisão adequada à fase de formação.",
        "A pessoa ainda está em formação. As atividades que pode realizar dependem da sua competência, fase de formação e supervisão. Uma profissional de obstetrícia qualificada continua responsável por assegurar a supervisão adequada dos cuidados."
      ]
    },
    "summary": "Profissional de enfermagem com especialização nesta área: {area}.",
    "difference": "Esta especialidade tem como foco {area}; inclui {scope}.",
    "specialties": {
      "cancer_cns": [
        "Enfermeiro ou enfermeira especialista em oncologia",
        "os cuidados oncológicos",
        "o apoio no diagnóstico, tratamento e acompanhamento"
      ],
      "breast_cancer_cns": [
        "Enfermeiro ou enfermeira especialista em cancro da mama",
        "os cuidados no cancro da mama",
        "o percurso de cuidados, tratamento e apoio"
      ],
      "cardiac_cns": [
        "Enfermeiro ou enfermeira especialista em cardiologia",
        "as doenças cardíacas",
        "o tratamento e apoio contínuo"
      ],
      "diabetes_cns": [
        "Enfermeiro ou enfermeira especialista em diabetes",
        "os cuidados da diabetes",
        "o tratamento, educação e cuidados em situações complexas"
      ],
      "respiratory_cns": [
        "Enfermeiro ou enfermeira especialista em doenças respiratórias",
        "as doenças pulmonares e respiratórias",
        "a avaliação, tratamento e apoio"
      ],
      "neurology_cns": [
        "Enfermeiro ou enfermeira especialista em neurologia",
        "as doenças neurológicas",
        "o tratamento e apoio"
      ],
      "palliative_care_cns": [
        "Enfermeiro ou enfermeira especialista em cuidados paliativos",
        "os cuidados paliativos",
        "o controlo dos sintomas, apoio e qualidade de vida em doenças graves"
      ]
    }
  },
  "it": {
    "midwife": {
      "consultant_midwife": [
        "Ostetrica consulente",
        "Ostetrica di grande esperienza con responsabilità cliniche avanzate, di leadership e di miglioramento dei servizi.",
        "L'ostetrica consulente ha competenze cliniche avanzate e responsabilità di leadership. Può contribuire all'assistenza complessa, alla consulenza specialistica e al miglioramento dei servizi di maternità."
      ],
      "student_midwife": [
        "Studente o studentessa di ostetricia",
        "Persona che si prepara a diventare ostetrica qualificata, con supervisione adeguata alla fase di formazione.",
        "La persona è ancora in formazione. Le attività che può svolgere dipendono dalle competenze, dal livello di formazione e dalla supervisione. Un'ostetrica qualificata assicura che l'assistenza sia adeguatamente supervisionata."
      ]
    },
    "summary": "Infermiere o infermiera con competenze specialistiche in questo ambito: {area}.",
    "difference": "L'ambito di lavoro è {area}; comprende {scope}.",
    "specialties": {
      "cancer_cns": [
        "Infermiere o infermiera specialista in oncologia",
        "l'assistenza oncologica",
        "il supporto durante diagnosi, trattamento e controlli successivi"
      ],
      "breast_cancer_cns": [
        "Infermiere o infermiera specialista nel tumore al seno",
        "l'assistenza per il tumore al seno",
        "il percorso di cura, il trattamento e il sostegno"
      ],
      "cardiac_cns": [
        "Infermiere o infermiera specialista in cardiologia",
        "le patologie cardiache",
        "il trattamento e il sostegno continuativo"
      ],
      "diabetes_cns": [
        "Infermiere o infermiera specialista in diabetologia",
        "l'assistenza per il diabete",
        "il trattamento, l'educazione terapeutica e i casi complessi"
      ],
      "respiratory_cns": [
        "Infermiere o infermiera specialista in pneumologia",
        "le patologie polmonari e respiratorie",
        "la valutazione, il trattamento e il supporto"
      ],
      "neurology_cns": [
        "Infermiere o infermiera specialista in neurologia",
        "le patologie neurologiche",
        "il trattamento e il sostegno"
      ],
      "palliative_care_cns": [
        "Infermiere o infermiera specialista in cure palliative",
        "le cure palliative",
        "il controllo dei sintomi, il sostegno e la qualità della vita nelle malattie gravi"
      ]
    }
  },
  "pl": {
    "midwife": {
      "consultant_midwife": [
        "Położna konsultantka",
        "Bardzo doświadczona położna zajmująca się zaawansowaną opieką kliniczną, kierowaniem zespołem i doskonaleniem usług.",
        "Położna konsultantka ma zaawansowane kompetencje kliniczne i przywódcze. Może uczestniczyć w opiece nad osobami o złożonych potrzebach, udzielać specjalistycznych porad i usprawniać opiekę położniczą."
      ],
      "student_midwife": [
        "Student lub studentka położnictwa",
        "Osoba przygotowująca się do zawodu położnej, pracująca pod nadzorem odpowiednim do etapu szkolenia.",
        "Osoba studiująca położnictwo nie ma jeszcze pełnych kwalifikacji zawodowych. Jej zadania zależą od etapu szkolenia, umiejętności i nadzoru. Wykwalifikowana położna odpowiada za zapewnienie właściwego nadzoru nad opieką."
      ]
    },
    "summary": "Specjalista lub specjalistka pielęgniarstwa — obszar specjalizacji: {area}.",
    "difference": "Ten specjalista zajmuje się obszarem: {area}; obejmuje to {scope}.",
    "specialties": {
      "cancer_cns": [
        "Pielęgniarka lub pielęgniarz specjalista onkologiczny",
        "opiekę onkologiczną",
        "wsparcie podczas diagnozy, leczenia i kontroli po leczeniu"
      ],
      "breast_cancer_cns": [
        "Pielęgniarka lub pielęgniarz specjalista raka piersi",
        "opiekę nad osobami z rakiem piersi",
        "ścieżkę leczenia, terapię i wsparcie"
      ],
      "cardiac_cns": [
        "Pielęgniarka lub pielęgniarz specjalista kardiologiczny",
        "opiekę nad osobami z chorobami serca",
        "leczenie i stałe wsparcie"
      ],
      "diabetes_cns": [
        "Pielęgniarka lub pielęgniarz specjalista diabetologiczny",
        "opiekę nad osobami z cukrzycą",
        "leczenie, edukację i opiekę w trudniejszych przypadkach"
      ],
      "respiratory_cns": [
        "Pielęgniarka lub pielęgniarz specjalista chorób układu oddechowego",
        "opiekę nad osobami z chorobami płuc i układu oddechowego",
        "ocenę stanu zdrowia, leczenie i wsparcie"
      ],
      "neurology_cns": [
        "Pielęgniarka lub pielęgniarz specjalista neurologiczny",
        "opiekę nad osobami z chorobami neurologicznymi",
        "leczenie i wsparcie"
      ],
      "palliative_care_cns": [
        "Pielęgniarka lub pielęgniarz specjalista opieki paliatywnej",
        "opiekę paliatywną",
        "łagodzenie objawów, wsparcie i jakość życia w poważnej chorobie"
      ]
    }
  },
  "ro": {
    "midwife": {
      "consultant_midwife": [
        "Moașă consultantă",
        "Moașă cu multă experiență, cu responsabilități clinice avansate, de conducere și de îmbunătățire a serviciilor.",
        "Moașa consultantă are competențe clinice avansate și responsabilități de conducere. Poate contribui la îngrijirea cazurilor complexe, consilierea de specialitate și îmbunătățirea serviciilor de maternitate."
      ],
      "student_midwife": [
        "Student sau studentă la moașe",
        "Persoană care se pregătește să devină moașă autorizată și lucrează sub supraveghere adecvată nivelului de pregătire.",
        "Studentul sau studenta este încă în pregătire. Activitățile permise depind de nivelul de pregătire, competență și supraveghere. O moașă autorizată se asigură că îngrijirea este supravegheată corespunzător."
      ]
    },
    "summary": "Specialist sau specialistă în asistență medicală pentru {area}.",
    "difference": "Această specializare se concentrează asupra {area}, inclusiv {scope}.",
    "specialties": {
      "cancer_cns": [
        "Asistent sau asistentă medicală specializată în oncologie",
        "îngrijirea persoanelor cu cancer",
        "sprijinul la diagnostic, tratament și monitorizare"
      ],
      "breast_cancer_cns": [
        "Asistent sau asistentă medicală specializată în cancer mamar",
        "îngrijirea persoanelor cu cancer de sân",
        "parcursul de îngrijire, tratamentul și sprijinul"
      ],
      "cardiac_cns": [
        "Asistent sau asistentă medicală specializată în cardiologie",
        "îngrijirea afecțiunilor cardiace",
        "tratamentul și sprijinul continuu"
      ],
      "diabetes_cns": [
        "Asistent sau asistentă medicală specializată în diabet",
        "îngrijirea persoanelor cu diabet",
        "tratamentul, educația și îngrijirea cazurilor complexe"
      ],
      "respiratory_cns": [
        "Asistent sau asistentă medicală specializată în boli respiratorii",
        "îngrijirea afecțiunilor pulmonare și respiratorii",
        "evaluarea, tratamentul și sprijinul"
      ],
      "neurology_cns": [
        "Asistent sau asistentă medicală specializată în neurologie",
        "îngrijirea afecțiunilor neurologice",
        "tratamentul și sprijinul"
      ],
      "palliative_care_cns": [
        "Asistent sau asistentă medicală specializată în îngrijiri paliative",
        "îngrijirea paliativă",
        "ameliorarea simptomelor, sprijinul și calitatea vieții în boli grave"
      ]
    }
  },
  "tr": {
    "midwife": {
      "consultant_midwife": [
        "Danışman ebe",
        "İleri klinik uzmanlık, liderlik ve hizmet geliştirme sorumlulukları olan çok deneyimli bir ebe.",
        "Danışman ebe, ileri düzey klinik uzmanlığa ve liderlik sorumluluklarına sahiptir. Karmaşık bakım durumlarında görev alabilir, uzman görüşü sunabilir ve doğum hizmetlerinin iyileştirilmesine katkıda bulunabilir."
      ],
      "student_midwife": [
        "Ebelik öğrencisi",
        "Ebe olmak üzere eğitim gören ve eğitim aşamasına uygun gözetim altında çalışan kişi.",
        "Ebelik öğrencisi henüz eğitimini tamamlamamıştır. Yapabileceği işler eğitim aşamasına, yeterliliğine ve gözetimine bağlıdır. Kayıtlı bir ebe, bakımın uygun biçimde gözetilmesini sağlamakla yükümlüdür."
      ]
    },
    "summary": "{area} uzmanlığı olan klinik hemşire.",
    "difference": "Bu uzmanlık {area} üzerine odaklanır; {scope} buna dahildir.",
    "specialties": {
      "cancer_cns": [
        "Kanser klinik uzman hemşiresi",
        "kanser bakımında",
        "tanı, tedavi ve takip sürecindeki desteği"
      ],
      "breast_cancer_cns": [
        "Meme kanseri klinik uzman hemşiresi",
        "meme kanseri bakımında",
        "bakım sürecini, tedaviyi ve desteği"
      ],
      "cardiac_cns": [
        "Kardiyoloji klinik uzman hemşiresi",
        "kalp hastalıklarının bakımında",
        "tedaviyi ve sürekli desteği"
      ],
      "diabetes_cns": [
        "Diyabet klinik uzman hemşiresi",
        "diyabet bakımında",
        "tedaviyi, eğitimi ve karmaşık vakalara desteği"
      ],
      "respiratory_cns": [
        "Solunum hastalıkları klinik uzman hemşiresi",
        "akciğer ve solunum hastalıklarının bakımında",
        "değerlendirmeyi, tedaviyi ve desteği"
      ],
      "neurology_cns": [
        "Nöroloji klinik uzman hemşiresi",
        "nörolojik hastalıkların bakımında",
        "tedaviyi ve desteği"
      ],
      "palliative_care_cns": [
        "Palyatif bakım klinik uzman hemşiresi",
        "palyatif bakımda",
        "belirti kontrolünü, desteği ve ciddi hastalıkta yaşam kalitesini"
      ]
    }
  },
  "fa": {
    "midwife": {
      "consultant_midwife": [
        "مامای مشاور ارشد",
        "مامایی بسیار باتجربه با مسئولیت‌های پیشرفته بالینی، رهبری حرفه‌ای و بهبود خدمات.",
        "مامای مشاور ارشد مهارت‌های بالینی پیشرفته و مسئولیت‌های رهبری دارد. ممکن است در مراقبت‌های پیچیده، ارائه مشاوره تخصصی و بهبود خدمات مامایی نقش داشته باشد."
      ],
      "student_midwife": [
        "دانشجوی مامایی",
        "فردی که برای ماما شدن آموزش می‌بیند و متناسب با مرحله آموزش خود تحت نظارت کار می‌کند.",
        "دانشجوی مامایی هنوز در حال آموزش است. نوع کارهایی که می‌تواند انجام دهد به مرحله آموزش، توانایی و میزان نظارت بستگی دارد. یک مامای ثبت‌شده مسئول اطمینان از نظارت مناسب بر مراقبت‌ها است."
      ]
    },
    "summary": "پرستار بالینی متخصص در زمینه {area}.",
    "difference": "تمرکز این تخصص بر {area} است و شامل {scope} می‌شود.",
    "specialties": {
      "cancer_cns": [
        "پرستار متخصص بالینی سرطان",
        "مراقبت از بیماران مبتلا به سرطان",
        "حمایت هنگام تشخیص، درمان و پیگیری"
      ],
      "breast_cancer_cns": [
        "پرستار متخصص بالینی سرطان پستان",
        "مراقبت از بیماران مبتلا به سرطان پستان",
        "مسیر مراقبت، درمان و حمایت"
      ],
      "cardiac_cns": [
        "پرستار متخصص بالینی قلب",
        "مراقبت از بیماری‌های قلبی",
        "درمان و حمایت مداوم"
      ],
      "diabetes_cns": [
        "پرستار متخصص بالینی دیابت",
        "مراقبت از بیماران مبتلا به دیابت",
        "درمان، آموزش و مراقبت از موارد پیچیده"
      ],
      "respiratory_cns": [
        "پرستار متخصص بالینی بیماری‌های تنفسی",
        "مراقبت از بیماری‌های ریه و دستگاه تنفس",
        "ارزیابی، درمان و حمایت"
      ],
      "neurology_cns": [
        "پرستار متخصص بالینی مغز و اعصاب",
        "مراقبت از بیماری‌های عصبی",
        "درمان و حمایت"
      ],
      "palliative_care_cns": [
        "پرستار متخصص بالینی مراقبت تسکینی",
        "مراقبت تسکینی",
        "کنترل علائم، حمایت و بهبود کیفیت زندگی در بیماری‌های جدی"
      ]
    }
  },
  "ur": {
    "midwife": {
      "consultant_midwife": [
        "کنسلٹنٹ مڈوائف",
        "نہایت تجربہ کار مڈوائف جو اعلیٰ طبی نگہداشت، قیادت اور زچگی کی خدمات بہتر بنانے کی ذمہ داریاں نبھاتی ہے۔",
        "کنسلٹنٹ مڈوائف کو اعلیٰ درجے کی طبی مہارت اور قیادت کا تجربہ ہوتا ہے۔ وہ پیچیدہ نگہداشت، خصوصی مشورے اور زچگی کی خدمات میں بہتری میں مدد دے سکتی ہے۔"
      ],
      "student_midwife": [
        "طالب علم مڈوائف",
        "مڈوائف بننے کی تربیت حاصل کرنے والا فرد جو اپنی تربیت کے مرحلے کے مطابق نگرانی میں کام کرتا ہے۔",
        "طالب علم مڈوائف ابھی زیرِ تربیت ہوتا ہے۔ وہ کیا کام کر سکتا ہے، اس کا انحصار تربیت کے مرحلے، صلاحیت اور نگرانی پر ہے۔ رجسٹرڈ مڈوائف مناسب نگرانی کو یقینی بنانے کی ذمہ دار رہتی ہے۔"
      ]
    },
    "summary": "{area} میں مہارت رکھنے والا کلینیکل نرسنگ ماہر۔",
    "difference": "یہ خصوصی کردار {area} پر مرکوز ہے، جس میں {scope} شامل ہے۔",
    "specialties": {
      "cancer_cns": [
        "کینسر کی کلینیکل اسپیشلسٹ نرس",
        "کینسر کی نگہداشت",
        "تشخیص، علاج اور بعد کی پیروی کے دوران مدد"
      ],
      "breast_cancer_cns": [
        "چھاتی کے کینسر کی کلینیکل اسپیشلسٹ نرس",
        "چھاتی کے کینسر کی نگہداشت",
        "نگہداشت کے مراحل، علاج اور مدد"
      ],
      "cardiac_cns": [
        "امراضِ قلب کی کلینیکل اسپیشلسٹ نرس",
        "دل کی بیماریوں کی نگہداشت",
        "علاج اور مسلسل مدد"
      ],
      "diabetes_cns": [
        "ذیابیطس کی کلینیکل اسپیشلسٹ نرس",
        "ذیابیطس کی نگہداشت",
        "علاج، تعلیم اور پیچیدہ حالات میں مدد"
      ],
      "respiratory_cns": [
        "سانس کی بیماریوں کی کلینیکل اسپیشلسٹ نرس",
        "پھیپھڑوں اور سانس کی بیماریوں کی نگہداشت",
        "جانچ، علاج اور مدد"
      ],
      "neurology_cns": [
        "اعصابی امراض کی کلینیکل اسپیشلسٹ نرس",
        "اعصابی بیماریوں کی نگہداشت",
        "علاج اور مدد"
      ],
      "palliative_care_cns": [
        "تسکینی نگہداشت کی کلینیکل اسپیشلسٹ نرس",
        "تسکینی (پالی ایٹو) نگہداشت",
        "علامات میں کمی، مریض اور اہلِ خانہ کی مدد اور سنگین بیماری میں زندگی کے معیار کی بہتری"
      ]
    }
  },
  "bn": {
    "midwife": {
      "consultant_midwife": [
        "পরামর্শক মিডওয়াইফ",
        "অত্যন্ত অভিজ্ঞ একজন মিডওয়াইফ, যাঁর উন্নত ক্লিনিক্যাল সেবা, নেতৃত্ব ও মাতৃসেবা উন্নয়নের দায়িত্ব রয়েছে।",
        "পরামর্শক মিডওয়াইফের উন্নত ক্লিনিক্যাল দক্ষতা ও নেতৃত্বের দায়িত্ব থাকে। তিনি জটিল পরিচর্যায় যুক্ত হতে পারেন, বিশেষজ্ঞ পরামর্শ দিতে পারেন এবং মাতৃসেবার মান উন্নয়নে সহায়তা করতে পারেন।"
      ],
      "student_midwife": [
        "মিডওয়াইফারি শিক্ষার্থী",
        "নিবন্ধিত মিডওয়াইফ হওয়ার প্রশিক্ষণ নিচ্ছেন এমন শিক্ষার্থী, যিনি প্রশিক্ষণের পর্যায় অনুযায়ী তত্ত্বাবধানে কাজ করেন।",
        "মিডওয়াইফারি শিক্ষার্থী এখনো প্রশিক্ষণরত। তিনি কী কাজ করতে পারবেন তা তাঁর প্রশিক্ষণের পর্যায়, দক্ষতা ও তত্ত্বাবধানের ওপর নির্ভর করে। নিবন্ধিত মিডওয়াইফ নিশ্চিত করেন যে পরিচর্যা যথাযথভাবে তত্ত্বাবধান করা হচ্ছে।"
      ]
    },
    "summary": "{area} বিষয়ে বিশেষজ্ঞ একজন ক্লিনিক্যাল নার্স।",
    "difference": "এই বিশেষজ্ঞের কাজ মূলত {area} নিয়ে, যার মধ্যে রয়েছে {scope}।",
    "specialties": {
      "cancer_cns": [
        "ক্যানসার ক্লিনিক্যাল নার্স বিশেষজ্ঞ",
        "ক্যানসারের পরিচর্যা",
        "রোগ নির্ণয়, চিকিৎসা ও ফলো-আপের সময় সহায়তা"
      ],
      "breast_cancer_cns": [
        "স্তন ক্যানসার ক্লিনিক্যাল নার্স বিশেষজ্ঞ",
        "স্তন ক্যানসারের পরিচর্যা",
        "পরিচর্যার বিভিন্ন ধাপ, চিকিৎসা ও সহায়তা"
      ],
      "cardiac_cns": [
        "হৃদ্‌রোগ ক্লিনিক্যাল নার্স বিশেষজ্ঞ",
        "হৃদ্‌রোগের পরিচর্যা",
        "চিকিৎসা ও নিয়মিত সহায়তা"
      ],
      "diabetes_cns": [
        "ডায়াবেটিস ক্লিনিক্যাল নার্স বিশেষজ্ঞ",
        "ডায়াবেটিসের পরিচর্যা",
        "চিকিৎসা, রোগীর শিক্ষা ও জটিল অবস্থায় সহায়তা"
      ],
      "respiratory_cns": [
        "শ্বাসযন্ত্রের রোগ ক্লিনিক্যাল নার্স বিশেষজ্ঞ",
        "ফুসফুস ও শ্বাসযন্ত্রের রোগের পরিচর্যা",
        "মূল্যায়ন, চিকিৎসা ও সহায়তা"
      ],
      "neurology_cns": [
        "স্নায়ুরোগ ক্লিনিক্যাল নার্স বিশেষজ্ঞ",
        "স্নায়ুরোগের পরিচর্যা",
        "চিকিৎসা ও সহায়তা"
      ],
      "palliative_care_cns": [
        "প্রশমনমূলক পরিচর্যা ক্লিনিক্যাল নার্স বিশেষজ্ঞ",
        "প্রশমনমূলক পরিচর্যা",
        "উপসর্গ উপশম, সহায়তা এবং গুরুতর অসুস্থতায় জীবনমান উন্নয়ন"
      ]
    }
  },
  "gu": {
    "midwife": {
      "consultant_midwife": [
        "કન્સલ્ટન્ટ મિડવાઇફ",
        "અનુભવી મિડવાઇફ, જે અદ્યતન ક્લિનિકલ સંભાળ, નેતૃત્વ અને પ્રસૂતિ સેવાઓના સુધારાની જવાબદારી સંભાળે છે.",
        "કન્સલ્ટન્ટ મિડવાઇફને અદ્યતન ક્લિનિકલ કુશળતા અને નેતૃત્વની જવાબદારીઓ હોય છે. તેઓ જટિલ સંભાળ, નિષ્ણાત સલાહ અને પ્રસૂતિ સેવાઓમાં સુધારો કરવામાં મદદ કરી શકે છે."
      ],
      "student_midwife": [
        "મિડવાઇફરીનો વિદ્યાર્થી અથવા વિદ્યાર્થિની",
        "નોંધાયેલ મિડવાઇફ બનવા તાલીમ લેતી વ્યક્તિ, જે પોતાની તાલીમના તબક્કા પ્રમાણે યોગ્ય દેખરેખ હેઠળ કામ કરે છે.",
        "મિડવાઇફરીનો વિદ્યાર્થી હજી તાલીમમાં હોય છે. તે કયાં કાર્યો કરી શકે તેનો આધાર તાલીમના તબક્કા, ક્ષમતા અને દેખરેખ પર હોય છે. નોંધાયેલ મિડવાઇફ યોગ્ય દેખરેખ હેઠળ સંભાળ મળે તેની ખાતરી માટે જવાબદાર રહે છે."
      ]
    },
    "summary": "{area} માટે વિશેષ તાલીમ ધરાવતી ક્લિનિકલ નર્સ.",
    "difference": "આ ભૂમિકા મુખ્યત્વે {area} સાથે જોડાયેલી છે; તેમાં {scope} સામેલ છે.",
    "specialties": {
      "cancer_cns": [
        "કેન્સર ક્લિનિકલ નર્સ નિષ્ણાત",
        "કેન્સરની સંભાળ",
        "નિદાન, સારવાર અને અનુસરણ દરમિયાન સહાય"
      ],
      "breast_cancer_cns": [
        "સ્તન કેન્સર ક્લિનિકલ નર્સ નિષ્ણાત",
        "સ્તન કેન્સરની સંભાળ",
        "સંભાળનો માર્ગ, સારવાર અને સહાય"
      ],
      "cardiac_cns": [
        "હૃદયરોગ ક્લિનિકલ નર્સ નિષ્ણાત",
        "હૃદયની બીમારીઓની સંભાળ",
        "સારવાર અને સતત સહાય"
      ],
      "diabetes_cns": [
        "ડાયાબિટીસ ક્લિનિકલ નર્સ નિષ્ણાત",
        "ડાયાબિટીસની સંભાળ",
        "સારવાર, શિક્ષણ અને જટિલ પરિસ્થિતિમાં સહાય"
      ],
      "respiratory_cns": [
        "શ્વસનરોગ ક્લિનિકલ નર્સ નિષ્ણાત",
        "ફેફસાં અને શ્વસનરોગોની સંભાળ",
        "મૂલ્યાંકન, સારવાર અને સહાય"
      ],
      "neurology_cns": [
        "ન્યુરોલોજી ક્લિનિકલ નર્સ નિષ્ણાત",
        "ચેતાતંત્રના રોગોની સંભાળ",
        "સારવાર અને સહાય"
      ],
      "palliative_care_cns": [
        "પેલિયેટિવ સંભાળ ક્લિનિકલ નર્સ નિષ્ણાત",
        "પેલિયેટિવ સંભાળ",
        "લક્ષણોમાં રાહત, સહાય અને ગંભીર બીમારીમાં જીવનની ગુણવત્તા"
      ]
    }
  },
  "pa": {
    "midwife": {
      "consultant_midwife": [
        "ਕੰਸਲਟੈਂਟ ਮਿਡਵਾਈਫ਼",
        "ਬਹੁਤ ਤਜਰਬੇਕਾਰ ਮਿਡਵਾਈਫ਼ ਜੋ ਉੱਨਤ ਕਲੀਨਿਕਲ ਦੇਖਭਾਲ, ਅਗਵਾਈ ਅਤੇ ਜਣੇਪਾ ਸੇਵਾਵਾਂ ਦੇ ਸੁਧਾਰ ਦੀ ਜ਼ਿੰਮੇਵਾਰੀ ਨਿਭਾਉਂਦੀ ਹੈ।",
        "ਕੰਸਲਟੈਂਟ ਮਿਡਵਾਈਫ਼ ਕੋਲ ਉੱਨਤ ਕਲੀਨਿਕਲ ਮਹਾਰਤ ਅਤੇ ਅਗਵਾਈ ਦੀ ਜ਼ਿੰਮੇਵਾਰੀ ਹੁੰਦੀ ਹੈ। ਉਹ ਜਟਿਲ ਦੇਖਭਾਲ, ਮਾਹਰ ਸਲਾਹ ਅਤੇ ਜਣੇਪਾ ਸੇਵਾਵਾਂ ਦੇ ਸੁਧਾਰ ਵਿੱਚ ਮਦਦ ਕਰ ਸਕਦੀ ਹੈ।"
      ],
      "student_midwife": [
        "ਮਿਡਵਾਈਫ਼ਰੀ ਦਾ ਵਿਦਿਆਰਥੀ ਜਾਂ ਵਿਦਿਆਰਥਣ",
        "ਰਜਿਸਟਰਡ ਮਿਡਵਾਈਫ਼ ਬਣਨ ਦੀ ਸਿਖਲਾਈ ਲੈ ਰਿਹਾ ਵਿਅਕਤੀ ਜੋ ਆਪਣੇ ਸਿਖਲਾਈ ਪੱਧਰ ਮੁਤਾਬਕ ਨਿਗਰਾਨੀ ਹੇਠ ਕੰਮ ਕਰਦਾ ਹੈ।",
        "ਵਿਦਿਆਰਥੀ ਹਾਲੇ ਸਿਖਲਾਈ ਲੈ ਰਿਹਾ ਹੁੰਦਾ ਹੈ। ਉਹ ਕੀ ਕਰ ਸਕਦਾ ਹੈ, ਇਹ ਉਸਦੇ ਸਿਖਲਾਈ ਪੱਧਰ, ਯੋਗਤਾ ਅਤੇ ਨਿਗਰਾਨੀ ਉੱਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ। ਰਜਿਸਟਰਡ ਮਿਡਵਾਈਫ਼ ਉਚਿਤ ਨਿਗਰਾਨੀ ਯਕੀਨੀ ਬਣਾਉਣ ਲਈ ਜ਼ਿੰਮੇਵਾਰ ਰਹਿੰਦੀ ਹੈ।"
      ]
    },
    "summary": "{area} ਵਿੱਚ ਮਾਹਰ ਕਲੀਨਿਕਲ ਨਰਸ.",
    "difference": "ਇਹ ਮਾਹਰ ਭੂਮਿਕਾ {area} ਉੱਤੇ ਕੇਂਦ੍ਰਿਤ ਹੈ, ਜਿਸ ਵਿੱਚ {scope} ਸ਼ਾਮਲ ਹੈ।",
    "specialties": {
      "cancer_cns": [
        "ਕੈਂਸਰ ਕਲੀਨਿਕਲ ਨਰਸ ਮਾਹਰ",
        "ਕੈਂਸਰ ਦੀ ਦੇਖਭਾਲ",
        "ਤਸ਼ਖੀਸ, ਇਲਾਜ ਅਤੇ ਬਾਅਦ ਦੀ ਨਿਗਰਾਨੀ ਵਿੱਚ ਸਹਾਇਤਾ"
      ],
      "breast_cancer_cns": [
        "ਛਾਤੀ ਦੇ ਕੈਂਸਰ ਦੀ ਕਲੀਨਿਕਲ ਨਰਸ ਮਾਹਰ",
        "ਛਾਤੀ ਦੇ ਕੈਂਸਰ ਦੀ ਦੇਖਭਾਲ",
        "ਦੇਖਭਾਲ ਦੇ ਪੜਾਅ, ਇਲਾਜ ਅਤੇ ਸਹਾਇਤਾ"
      ],
      "cardiac_cns": [
        "ਦਿਲ ਦੀਆਂ ਬਿਮਾਰੀਆਂ ਦੀ ਕਲੀਨਿਕਲ ਨਰਸ ਮਾਹਰ",
        "ਦਿਲ ਦੀਆਂ ਬਿਮਾਰੀਆਂ ਦੀ ਦੇਖਭਾਲ",
        "ਇਲਾਜ ਅਤੇ ਲਗਾਤਾਰ ਸਹਾਇਤਾ"
      ],
      "diabetes_cns": [
        "ਸ਼ੂਗਰ ਦੀ ਕਲੀਨਿਕਲ ਨਰਸ ਮਾਹਰ",
        "ਸ਼ੂਗਰ ਦੀ ਦੇਖਭਾਲ",
        "ਇਲਾਜ, ਸਿੱਖਿਆ ਅਤੇ ਜਟਿਲ ਮਾਮਲਿਆਂ ਵਿੱਚ ਸਹਾਇਤਾ"
      ],
      "respiratory_cns": [
        "ਸਾਹ ਦੀਆਂ ਬਿਮਾਰੀਆਂ ਦੀ ਕਲੀਨਿਕਲ ਨਰਸ ਮਾਹਰ",
        "ਫੇਫੜਿਆਂ ਅਤੇ ਸਾਹ ਦੀਆਂ ਬਿਮਾਰੀਆਂ ਦੀ ਦੇਖਭਾਲ",
        "ਜਾਂਚ, ਇਲਾਜ ਅਤੇ ਸਹਾਇਤਾ"
      ],
      "neurology_cns": [
        "ਨਿਊਰੋਲੋਜੀ ਕਲੀਨਿਕਲ ਨਰਸ ਮਾਹਰ",
        "ਤੰਤਰਿਕਾ ਪ੍ਰਣਾਲੀ ਦੀਆਂ ਬਿਮਾਰੀਆਂ ਦੀ ਦੇਖਭਾਲ",
        "ਇਲਾਜ ਅਤੇ ਸਹਾਇਤਾ"
      ],
      "palliative_care_cns": [
        "ਪੈਲੀਏਟਿਵ ਕੇਅਰ ਕਲੀਨਿਕਲ ਨਰਸ ਮਾਹਰ",
        "ਰਾਹਤ ਦੇਣ ਵਾਲੀ ਦੇਖਭਾਲ",
        "ਲੱਛਣਾਂ ਤੋਂ ਰਾਹਤ, ਸਹਾਇਤਾ ਅਤੇ ਗੰਭੀਰ ਬਿਮਾਰੀ ਵਿੱਚ ਜੀਵਨ ਦੀ ਗੁਣਵੱਤਾ"
      ]
    }
  },
  "so": {
    "midwife": {
      "consultant_midwife": [
        "Umuliso lataliye sare",
        "Umuliso khibrad badan leh oo masuul ka ah daryeelka caafimaad ee horumarsan, hoggaaminta iyo hagaajinta adeegyada hooyada.",
        "Umulisada lataliyaha ahi waxay leedahay khibrad caafimaad iyo masuuliyado hoggaamineed oo sare. Waxay ka qayb qaadan kartaa daryeelka xaaladaha adag, talooyinka takhasuska iyo hagaajinta adeegyada hooyada."
      ],
      "student_midwife": [
        "Ardayga umulisada",
        "Qof baranaya inuu noqdo umuliso diiwaangashan, kuna shaqeeya kormeer ku habboon heerka tababarkiisa.",
        "Ardayga umulisadu weli wuu tababaranayaa. Shaqooyinka uu qaban karo waxay ku xiran yihiin heerka tababarka, kartida iyo kormeerka. Umuliso diiwaangashan ayaa mas'uul ka ah in daryeelka si habboon loo kormeero."
      ]
    },
    "summary": "Kalkaaliye caafimaad oo takhasus u leh {area}.",
    "difference": "Takhasuskani wuxuu diiradda saaraa {area}, waxaana ka mid ah {scope}.",
    "specialties": {
      "cancer_cns": [
        "Kalkaaliyaha takhasuska kansarka",
        "daryeelka kansarka",
        "taageerada ogaanshaha, daaweynta iyo dabagalka"
      ],
      "breast_cancer_cns": [
        "Kalkaaliyaha takhasuska kansarka naaska",
        "daryeelka kansarka naaska",
        "marxaladaha daryeelka, daaweynta iyo taageerada"
      ],
      "cardiac_cns": [
        "Kalkaaliyaha takhasuska cudurrada wadnaha",
        "daryeelka cudurrada wadnaha",
        "daaweynta iyo taageerada joogtada ah"
      ],
      "diabetes_cns": [
        "Kalkaaliyaha takhasuska sonkorowga",
        "daryeelka sonkorowga",
        "daaweynta, waxbarashada bukaanka iyo xaaladaha adag"
      ],
      "respiratory_cns": [
        "Kalkaaliyaha takhasuska cudurrada neefmareenka",
        "daryeelka cudurrada sambabada iyo neefsashada",
        "qiimeynta, daaweynta iyo taageerada"
      ],
      "neurology_cns": [
        "Kalkaaliyaha takhasuska cudurrada neerfaha",
        "daryeelka cudurrada neerfaha",
        "daaweynta iyo taageerada"
      ],
      "palliative_care_cns": [
        "Kalkaaliyaha takhasuska daryeelka nasinta",
        "daryeelka nasinta",
        "yaraynta calaamadaha, taageerada iyo tayada nolosha marka xanuunku culus yahay"
      ]
    }
  },
  "tl": {
    "midwife": {
      "consultant_midwife": [
        "Consultant Midwife (dalubhasang komadrona)",
        "Napakabihasang komadrona na may mataas na tungkulin sa klinikal na pangangalaga, pamumuno at pagpapabuti ng serbisyong pangmaternity.",
        "Ang consultant midwife ay may mataas na antas ng klinikal na kasanayan at pananagutan sa pamumuno. Maaari siyang tumulong sa masalimuot na pangangalaga, magbigay ng payong espesyalista at magpaunlad ng mga serbisyong pangmaternity."
      ],
      "student_midwife": [
        "Estudyante ng pagkokomadrona",
        "Taong nagsasanay upang maging rehistradong komadrona at nagtatrabaho nang may angkop na pangangasiwa para sa antas ng pagsasanay.",
        "Nagsasanay pa ang estudyante. Nakasalalay ang mga gawaing maaari niyang gawin sa antas ng pagsasanay, kakayahan at pangangasiwa. Pananagutan ng rehistradong komadrona na matiyak ang angkop na pangangasiwa sa pangangalaga."
      ]
    },
    "summary": "Klinikal na nars na espesyalista sa {area}.",
    "difference": "Nakatuon ang espesyalisasyong ito sa {area}, kasama ang {scope}.",
    "specialties": {
      "cancer_cns": [
        "Klinikal na nars na espesyalista sa kanser",
        "pangangalaga sa kanser",
        "suporta sa panahon ng pagsusuri, paggamot at follow-up"
      ],
      "breast_cancer_cns": [
        "Klinikal na nars na espesyalista sa kanser sa suso",
        "pangangalaga sa kanser sa suso",
        "mga hakbang sa pangangalaga, paggamot at suporta"
      ],
      "cardiac_cns": [
        "Klinikal na nars na espesyalista sa sakit sa puso",
        "pangangalaga sa sakit sa puso",
        "paggamot at tuloy-tuloy na suporta"
      ],
      "diabetes_cns": [
        "Klinikal na nars na espesyalista sa diabetes",
        "pangangalaga sa diabetes",
        "paggamot, edukasyon at pagharap sa masalimuot na kaso"
      ],
      "respiratory_cns": [
        "Klinikal na nars na espesyalista sa sakit sa paghinga",
        "pangangalaga sa sakit sa baga at paghinga",
        "pagtatasa, paggamot at suporta"
      ],
      "neurology_cns": [
        "Klinikal na nars na espesyalista sa neurolohiya",
        "pangangalaga sa mga sakit sa sistema ng nerbiyos",
        "paggamot at suporta"
      ],
      "palliative_care_cns": [
        "Klinikal na nars na espesyalista sa palliative care",
        "pangangalagang palliative",
        "pagpapagaan ng sintomas, suporta at kalidad ng buhay sa malubhang sakit"
      ]
    }
  },
  "zh": {
    "midwife": {
      "consultant_midwife": [
        "顾问助产士",
        "经验丰富、承担高级临床工作、专业领导和产科服务改进职责的助产士。",
        "顾问助产士具有丰富的临床经验和领导职责，可能参与复杂的孕产期护理、提供专业建议、改进服务或开展专业指导。"
      ],
      "student_midwife": [
        "助产专业学生",
        "正在接受助产专业培训的学生，按照其培训阶段和能力在适当监督下提供护理。",
        "助产专业学生尚未完成培训。其可承担的工作取决于培训阶段、个人能力和监督安排。注册助产士负责确保所提供的护理得到适当监督。"
      ]
    },
    "summary": "专注于{area}的临床专科护士。",
    "difference": "这一专科重点关注{area}，包括{scope}。",
    "specialties": {
      "cancer_cns": [
        "癌症临床专科护士",
        "癌症护理",
        "诊断、治疗和随访期间的支持"
      ],
      "breast_cancer_cns": [
        "乳腺癌临床专科护士",
        "乳腺癌护理",
        "诊疗过程、治疗和支持"
      ],
      "cardiac_cns": [
        "心脏病临床专科护士",
        "心脏病护理",
        "治疗和持续支持"
      ],
      "diabetes_cns": [
        "糖尿病临床专科护士",
        "糖尿病护理",
        "治疗、健康教育及复杂病例的支持"
      ],
      "respiratory_cns": [
        "呼吸系统疾病临床专科护士",
        "肺部和呼吸系统疾病护理",
        "评估、治疗和支持"
      ],
      "neurology_cns": [
        "神经系统疾病临床专科护士",
        "神经系统疾病护理",
        "治疗和支持"
      ],
      "palliative_care_cns": [
        "姑息治疗临床专科护士",
        "姑息治疗",
        "缓解症状、提供支持以及改善严重疾病患者的生活质量"
      ]
    }
  }
};
